import { ApiResponsePage404 } from 'data-source/types.wp'
import { codecGetMissedProps } from 'data-source/mappers/codecGetMissedProps'
import { headPropsMapper } from 'data-source/mappers/headPropsMapper'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { metaMapper, MetaMapperOpts } from 'data-source/mappers/metaMapper'
import { DSPageNotFound, LinkedLinkProps } from 'shared-definitions/types'
import { OnePostWithAuthorMapperOpts } from './onePostWithAuthorMapper'

interface CodecGetPage404Opts extends OnePostWithAuthorMapperOpts, MetaMapperOpts {
  pagePath: string
  homeLink: LinkedLinkProps
}

export function codecGetPage404(
  raw: ApiResponsePage404,
  opts: CodecGetPage404Opts
): DSPageNotFound {
  const input = raw.data
  return {
    head: headPropsMapper(input.head),
    pagePath: opts.pagePath,
    sections: null,
    ampPagePath: null,
    meta: metaMapper({ ...input, content: {} }, [], opts),
    title: input.content.title,
    resource: '404-page',
    subtitle: input.content.subtitle,
    buttonHome: {
      label: input.content.button_label,
      pLink: opts.homeLink,
    },
    image: imageMapper(input.content.image, opts),
    postsTitle: input.content.posts.title,
    postsSubtitle: input.content.posts.subtitle,
    ...codecGetMissedProps(input.content.posts.content, opts),
  }
}
